import { render, staticRenderFns } from "./CourseChecklistGroup.vue?vue&type=template&id=500d1fa0&lang=pug&"
import script from "./CourseChecklistGroup.vue?vue&type=script&lang=js&"
export * from "./CourseChecklistGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports